import React, { useState } from 'react';

const ExpandableText = ({ text, maxChars = 50 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (!text) return null;
    if (text.length <= maxChars) return <span>{text}</span>;
    return (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.4', fontSize: '0.9em' }}>
            {isExpanded ? text : `${text.substring(0, maxChars)}... `}
            <span 
                onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                }}
                style={{ 
                    color: '#002b5b', 
                    cursor: 'pointer', 
                    fontWeight: '600',
                    fontSize: '0.85em',
                    display: 'block',
                    marginTop: '4px'
                }}
            >
                {isExpanded ? 'Voir moins' : 'voir plus'}
            </span>
        </div>
    );
};

export default ExpandableText;
